<template>
  <div class="onboardingContainer">
    <v-col class="onboarding-content">
      <v-form
        class="form-on-boarding"
        ref="formOnBoarding"
        v-model="valid"
        lazy-validation
      >
        <div class="form-inputs-wrapper">
          <div class="form-header-wrapper">
            <img
              :src="require('@/assets/img/icons/icon.png')"
              width="90"
              class="mx-auto"
            />
          </div>
          <v-text-field
            v-model="name"
            label="Nombre de pila"
            :rules="rules"
            class="capitalize"
            @change="name = $event"
            :disabled="getDisabledInputs('name')"
            :style="styles"
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            @change="email = $event"
            :disabled="getDisabledInputs('email')"
            :style="styles"
          ></v-text-field>
          <b :style="styles">¿Tienes hijos o los tendrás pronto?</b>
          <v-sheet>
            <v-switch
              inset
              v-model="has_children"
              :label="has_children ? 'Sí' : 'No'"
              @change="has_children = $event"
              :disabled="getDisabledInputs('has_children')"
              :style="styles"
            ></v-switch>
          </v-sheet>
          <div v-if="has_children">
            <v-dialog
              v-for="(itemField, index) in children_birthdate"
              v-model="itemField.show"
              ref="children_birthdate"
              :return-value.sync="itemField.value"
              :key="`childrenBirthdate${index}`"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <p v-show="index === 0" :style="styles">
                  Indica la fecha de nacimiento de tus hijos
                </p>
                <v-text-field
                  v-model="itemField.value"
                  prepend-icon="mdi-calendar-month-outline"
                  readonly
                  :rules="rulesRequired"
                  :label="
                    `Fecha de nacimiento de tu ${children_placeholder_texts[index]}`
                  "
                  @change="itemField.value = $event"
                  :disabled="getDisabledInputs('children_birthdate')"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    v-show="index > 0"
                    @click="remove(index)"
                    slot="append"
                    color="red"
                    >mdi-minus</v-icon
                  >
                </v-text-field>
              </template>
              <v-date-picker
                :active-picker.sync="itemField.activePicker"
                v-model="itemField.value"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="itemField.show = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.children_birthdate[index].save(itemField.value)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <div
              class="d-flex align-center mb-10"
              @click="add()"
              v-if="childrenBirthdateLength"
            >
              <v-btn text icon>
                <v-icon size="16" color="primary">
                  mdi-plus
                </v-icon>
              </v-btn>
              <span style="color:#1976d2; font-size:14px" :style="stylesAddOtheChild"
                >Añadir otro hijo</span
              >
            </div>
          </div>
        </div>
        <div class="form-buttons-wrapper">
          <v-btn
            :disabled="!valid"
            large
            block
            color="primary"
            class="rounded-lg"
            @click="validate"
            :style="styles"
          >
            Siguiente
          </v-btn>
        </div>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { convertEmToPixels } from '@/helper/helper'
import { _ } from 'vue-underscore'
const profileFields = {
  name: null,
  email: null,
  has_children: true,
  children_birthdate: [
    {
      value: ''
    }
  ]
}

export default {
  name: 'OnBoarding',
  created () {
    this.callProfileAction()
  },
  data: () => {
    let initialized = {
      modalBirthdate: false,
      activePicker: null,
      valid: true,
      loading: true,
      saving: null,
      children_placeholder_texts: [
        'primer hijo',
        'segundo hijo',
        'tercer hijo',
        'cuarto hijo',
        'quinto hijo',
        'sexto hijo',
        'séptimo hijo',
        'octavo hijo'
      ],
      rules: [value => (value && value.length >= 3) || 'Min 3 characters'],
      emailRules: [v => /.+@.+\..+/.test(v) || 'E-mail debe ser válido'],
      rulesRequired: [v => !!v || 'Required']
    }
    for (const fieldKey in profileFields) {
      initialized[fieldKey] = profileFields[fieldKey]
    }
    return initialized
  },
  watch: {
    children_birthdate: {
      handler (item) {
        item.activePicker = 'YEAR'
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getProfileData']),
    childrenBirthdateLength: function () {
      return this.children_birthdate.length <= 7
    },
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    },
    stylesAddOtheChild () {
      const result = convertEmToPixels(14)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    ...mapActions({
      profileAction: 'GET_PROFILE',
      saveBoarding: 'ONBOARDING',
      addChangeToQueue: 'ADD_TO_QUEUE'
    }),
    callProfileAction () {
      this.profileAction().then(profile => {
        profile.children_birthdate = _.isEmpty(profile.children_birthdate)
          ? ['']
          : profile.children_birthdate
        for (const field in profile) {
          this[field] = _.isArray(profileFields[field])
            ? (profile[field] || []).map(val => ({ value: val }))
            : profile[field]
        }
        this.loading = false
      })
    },
    validate () {
      let dataToSend = {}
      for (const fieldKey in profileFields) {
        dataToSend[fieldKey] = _.isArray(this[fieldKey])
          ? this[fieldKey].map(({ value }) => value)
          : this[fieldKey]
      }
      this.$refs.formOnBoarding.validate() &&
        this.saveBoarding({ ...dataToSend, onboarding: false }).then(() => {
          this.addChangeToQueue({
            currentScreen: 'users',
            action: 'onboarding',
            fieldsName: [
              'name',
              'onboarding',
              'has_children',
              'children_birthdate',
              'email',
              'disabled_fields'
            ]
          })
        })
    },
    add () {
      let value = {
        value: '',
        show: 'false'
      }
      this.children_birthdate.push(value)
    },
    remove (index) {
      this.children_birthdate.splice(index, 1)
    },
    getDisabledInputs (name) {
      return _.indexOf(this.getProfileData.disabled_fields, name) > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Onboarding.vue